module.exports = __webpack_public_path__ + "static/media/0174_Medium.404eb72c.jpg";